import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';
import { GlobalParticipant } from 'app/projects/user/src/lib/models/participant.model';
import { User } from 'app/projects/user/src/lib/models/user';
import { TeamMember } from './team-member.model';
import { Team } from './team.model';
import { UserTeam } from './user-team.model';

export class TeamsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'TeamsStateModel';

    teamMembers: TeamMember[];
    teamMembersTotalCount: number = 0;
    teamMembersLoading: boolean = false;
    teamMembersUsers: GlobalParticipant[];
    teamLeaders: User[] = [];
    teamWatchers: User[] = [];
    userTeams: UserTeam[] = [];
    teamSubTeams: Team[] = [];
    teamSubTeamsTotalCount: number = 0;
    teamSubTeamsLoading: boolean = false;
    teamLeaderTeams: Team[] = [];
    userProgress: TeamMember = null;
    userOtherTeams: Team[] = [];
    teamMemberTeams: Team[] = [];

    constructor() {
        super(TeamsStateModel.identifier);
    }
}
